import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LandingComponent } from './Landing/landing.component';
import { HomeComponent } from './Home/home.component';
import {ContactComponent} from './contact/contact.component';
import {BenefitComponent} from './benefit/benefit.component';
import {ProfileComponent} from './profile/profile.component';
import {AuthorizationComponent} from './authorization/authorization.component';
import {RegisterComponent} from './register/register.component';
import {OtpComponent} from './otp/otp.component';
import {ProvidersComponent} from './providers/providers.component';
import {ProviderDetailComponent} from './provider-detail/provider-detail.component';
import {ProviderOthersComponent} from './provider-others/provider-others.component';
import {FormsComponent} from './forms/forms.component';
import {InteliSearchComponent} from './inteli-search/inteli-search.component';
import {ProviderLocationComponent} from './provider-location/provider-location.component';
import {ProviderWaitComponent} from './provider-wait/provider-wait.component';
import {CheckoutComponent} from './checkout/checkout.component';
import {PaymentComponent} from './payment/payment.component';
import {ConfirmationComponent} from './confirmation/confirmation.component';
import {WaitListComponent} from './wait-list/wait-list.component';
import {RenovationComponent} from './renovation/renovation.component';
import {AuthGuard} from './auth.guard';
import {SettingsComponent} from './settings/settings.component';
import {CouponsComponent} from './coupons/coupons.component';
import {HomeContentComponent} from './home-content/home-content.component';
import {EmergencyComponent} from './emergency/emergency.component';
import { IndividualComponent } from './individual/individual.component';
import { EnterpriseComponent } from './enterprise/enterprise.component';
import { ImportantPhonesComponent } from './important-phones/important-phones.component';
import { DentalAssistanceComponent } from './dental-assistance/dental-assistance.component';
import { DentalAccessComponent } from './dental-access/dental-access.component';
import { ForgotIdComponent } from './forgot-id/forgot-id.component';
import { CannotLoginComponent } from './cannot-login/cannot-login.component';
import { GlossaryComponent } from './glossary/glossary.component';
import { NewAuthorizationComponent } from './new-authorization/new-authorization.component';
import { LandingCMIComponent } from './landing-cmi/landing-cmi.component';
import { NewClaimComponent } from './new-claim/new-claim.component';
import { ClaimsComponent } from './claims/claims.component';
import { ProviderModuleComponent } from './provider-module/provider-module.component';


const routes: Routes = [
  { path: '', component: LandingComponent},
  { path: 'login', component: LoginComponent },
  { path: 'cmi', component: LandingCMIComponent },
  { path: 'otp', component: OtpComponent},
  { path: 'register', component: RegisterComponent},
  { path: 'individual', component: IndividualComponent},
  { path: 'enterprise', component: EnterpriseComponent},
  { path: 'forgot-id', component: ForgotIdComponent},
  { path: 'cannot-login', component: CannotLoginComponent},
  { path: 'provider-module', component: ProviderModuleComponent },
  //{ path: 'telemedicine/:id/:code', component: TelemedicineComponent},
  { path: 'home', component: HomeComponent,
    children: [
      { path: 'authorization', component: AuthorizationComponent },
      { path: 'emergency', component: EmergencyComponent },
      { path: 'content', component: HomeContentComponent },
      { path: 'coupons', component: CouponsComponent},
      { path: 'profile', component: ProfileComponent },
      { path: 'benefits', component: BenefitComponent },
      { path: 'contact', component: ContactComponent},
      { path: 'forms', component: FormsComponent },
      { path: 'renovation', component: RenovationComponent },
      { path: 'inteli-search', component: InteliSearchComponent },
      { path: 'providersearch/:type', component: ProviderOthersComponent },
      { path: 'providersearch/:type/:parent', component: ProviderOthersComponent},
      { path: 'providersearch/:type/:parent/:ct/:tp/:dp/:tn/:sp/:nm/:tm', component: ProviderOthersComponent },
      { path: 'provider-detail', component: ProviderDetailComponent },
      { path: 'providers', component: ProvidersComponent},
      { path: 'locations', component: ProviderLocationComponent },
      { path: 'orders', component: ProviderWaitComponent},
      { path: 'checkout', component: CheckoutComponent },
      { path: 'payment', component: PaymentComponent },
      { path: 'confirmation', component: ConfirmationComponent },
      { path: 'wait', component: WaitListComponent },
      { path: 'settings', component: SettingsComponent },
      { path: 'important-phones', component: ImportantPhonesComponent },
      { path: 'dental-assistance', component: DentalAssistanceComponent },
      { path: 'dental-access', component: DentalAccessComponent },
      { path: 'glossary', component: GlossaryComponent },
      { path: 'new-authorization', component: NewAuthorizationComponent },
      { path: 'new-claim', component: NewClaimComponent },
      { path: 'claims', component: ClaimsComponent },
    ], canActivate: [AuthGuard]
  },
  
  /* { path: 'hero/:id',      component: HeroDetailComponent },
  {
    path: 'heroes',
    component: HeroListComponent,
    data: { title: 'Heroes List' }
  },
  { path: '',
    redirectTo: '/heroes',
    pathMatch: 'full'
  },
  { path: '**', component: PageNotFoundComponent } */
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
